export class CandidateAISummary {
  id: number;
  uuid: string;
  entityId: number;
  entityType: string; // e.g. "hr_cv"
  type: string; // e.g. "hr_cv"
  lang: string; // e.g. "en"
  model: string; // e.g. "openai"
  summary: string;
  createdAt: string; // ISO datetime string
  updatedAt: string; // ISO datetime string
  deletedAt: string | null;
}
